export class RealTimeCommunicationConfigurationError extends Error {
  constructor(message: string) {
    super(message);

    Object.setPrototypeOf(this, RealTimeCommunicationConfigurationError.prototype);
    this.name = 'RealTimeCommunicationConfigurationError';
  }
}
